import { Injectable } from '@angular/core';
import { Product } from '../entities/product';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends BaseTableService<Product> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/product';
  }
  
}
